import React from 'react';
import { FileIcon, DownloadIcon, TrashIcon, UploadIcon } from 'lucide-react';
export const DocumentsTab = ({
  data
}) => {
  return <div data-id="element-305">
      <h2 className="text-lg font-medium mb-4" data-id="element-306">Proof of Address</h2>
      <div className="border border-gray-200 rounded-lg p-4 mb-8" data-id="element-307">
        <div className="flex items-center" data-id="element-308">
          <div className="bg-red-100 p-2 rounded-lg mr-4" data-id="element-309">
            <FileIcon size={24} className="text-red-600" data-id="element-310" />
          </div>
          <div className="flex-1" data-id="element-311">
            <div className="flex justify-between" data-id="element-312">
              <div data-id="element-313">
                <h3 className="font-medium" data-id="element-314">Proof of Address.pdf</h3>
                <p className="text-sm text-gray-500" data-id="element-315">05/15/2023</p>
              </div>
              <div className="flex space-x-2" data-id="element-316">
                <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-317">
                  <DownloadIcon size={18} data-id="element-318" />
                </button>
                <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-319">
                  <TrashIcon size={18} data-id="element-320" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-lg font-medium mb-4" data-id="element-321">Additional Documents</h2>
      <div className="border border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center bg-gray-50" data-id="element-322">
        <div className="bg-white p-3 rounded-full mb-4 shadow-sm" data-id="element-323">
          <UploadIcon size={24} className="text-[#5c5cf5]" data-id="element-324" />
        </div>
        <p className="text-gray-700 mb-2" data-id="element-325">Drag and drop files here or</p>
        <button className="text-[#5c5cf5] font-medium" data-id="element-326">Click to upload</button>
        <p className="text-xs text-gray-500 mt-2" data-id="element-327">
          Supported formats: PDF, JPG, PNG (max 10MB)
        </p>
      </div>
    </div>;
};